import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import './FactAboutWeatherProtection.css';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import { FactsAboutWeatherProtection } from '../../../api';
import YesOrNoCheckbox from '../../molecules/yesornocheckbox/YesOrNoCheckbox';
import { Utils } from '../../../utilities/Utils';
import DateBox from '../../molecules/labelandtextbox/DateBox';
import NumberBox from '../../molecules/labelandtextbox/NumberBox';

interface FactsAboutWeatherProtectionProp {
  factsAboutWeatherProtection: FactsAboutWeatherProtection;
  setFactsAboutWeatherProtection?: React.Dispatch<React.SetStateAction<FactsAboutWeatherProtection | null | undefined>>;
  onUpdate: (newObject: FactsAboutWeatherProtection) => void;
}

const FactAboutWeatherProtection: React.FC<FactsAboutWeatherProtectionProp> = (props) => {

  const handleChange = (updatedData: Partial<FactsAboutWeatherProtection>) => {
    const newObject = { ...props.factsAboutWeatherProtection, ...updatedData };
    props.setFactsAboutWeatherProtection?.(newObject);
    props.onUpdate(newObject);
  };

  const handleCalculatedSnowLoadSelection = (
    selectedOption: keyof Pick<
      FactsAboutWeatherProtection,
      | 'calculatedSnowLoadNone'
      | 'calculatedSnowLoadZeroPointSix'
      | 'calculatedSnowLoadAccordingToEuroCode'
    >
  ) => {
    handleChange({
      calculatedSnowLoadNone: selectedOption === 'calculatedSnowLoadNone',
      calculatedSnowLoadZeroPointSix: selectedOption === 'calculatedSnowLoadZeroPointSix',
      calculatedSnowLoadAccordingToEuroCode:
        selectedOption === 'calculatedSnowLoadAccordingToEuroCode',
    });
  };

  return (
    <Container className='tablecolor'>
      <Row xs={12} md={2} lg={3}>
        <Col>
          <LabelAndTextBox title='BESTÄLLARE' remark={props.factsAboutWeatherProtection.customerName}
            onChange={(value) => handleChange({ customerName: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='KUND KONTAKTPERSON/TEL' remark={props.factsAboutWeatherProtection.customerContactNamePhone}
            onChange={(value) => handleChange({ customerContactNamePhone: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='ARBETSPLATS' remark={props.factsAboutWeatherProtection.projectAddress}
            onChange={(value) => handleChange({ projectAddress: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='STÄLLNINGSENTREPRENÖR' remark={props.factsAboutWeatherProtection.scaffoldingCompany}
            onChange={(value) => handleChange({ scaffoldingCompany: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='KONTAKTPERSON/TEL' remark={props.factsAboutWeatherProtection.contactNameAndPhoneNumberSTB}
            onChange={(value) => handleChange({ contactNameAndPhoneNumberSTB: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='SNÖRÖJNINGSMETOD' remark={props.factsAboutWeatherProtection.snowClearingMethod}
            onChange={(value) => handleChange({ snowClearingMethod: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='JOURRUTIN' remark={props.factsAboutWeatherProtection.onCallRoutine}
            onChange={(value) => handleChange({ onCallRoutine: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='JOURTEL' remark={props.factsAboutWeatherProtection.onCallPhoneNumber}
            onChange={(value) => handleChange({ onCallPhoneNumber: value })} />
        </Col>
        <Col>
          <LabelAndTextBox title='TYP AV VÄDERSKYDD' remark={props.factsAboutWeatherProtection.typeOfWeatherProtection}
            onChange={(value) => handleChange({ typeOfWeatherProtection: value })} />
        </Col>
      </Row>
      <Row className='wind-metrics-row'>
        <Col lg={3} md={6} xs={12}>
          <div className="input-section-2">
            <NumberBox title='REFERENSVINDHASTIGHET M/S' defaultValue={props.factsAboutWeatherProtection.referenceWindSpeed}
              onChange={(value) => handleChange({ referenceWindSpeed: value })} />
          </div>
        </Col>
        <Col lg={3} md={6} xs={12}>
          <div className="input-section-2">
            <NumberBox title='TÄRRÄNGTYP 0-1V' defaultValue={props.factsAboutWeatherProtection.terrainType}
              onChange={(value) => handleChange({ terrainType: value })} />
          </div>
        </Col>
        <Col lg={3} md={6} xs={12}>
          <div className="input-section-2">
            <NumberBox title='HÖJD ÖVER MARK' defaultValue={props.factsAboutWeatherProtection.heightOverGround}
              onChange={(value) => handleChange({ heightOverGround: value })} />
          </div>
        </Col>
        <Col lg={3} md={6} xs={12} className='characteristic-pressure-col'>
          <div className="input-section-2">
            <NumberBox title='KARAKTERISTISK HASTIGHETSTRYCK kN/m2' defaultValue={props.factsAboutWeatherProtection.characteristicSpeedPressure}
              onChange={(value) => handleChange({ characteristicSpeedPressure: value })} />
          </div>
        </Col>
      </Row>
      <Col>
        <div className="important-section">
          <h1>VIKTIGT!</h1>
          <p>
            •Referensvindhastighet för dimensionering
            vid den aktuella uppställningsplatsen
            hämtas ur Boverkets konstruktionsregler
            EKS.  <br /><br />
            •Terrängtyp för dimensionering vid den
            aktuella uppställningsplatsen hämtas ur
            Eurokod.<br /><br />
            •Karakteristiskt hastighetstryck hämtas
            ur Boverkets konstruktionsregler EKS. <br /><br />
            •Om eventuell stödställning även används
            som arbetsställning skall även
            ”Fakta om ställning/Egenkontroll ställning”
            fyllas i för stödställningen och
            komplettera denna handling.<br /><br />
            •Ställningsentreprenören utför egenkontroll
            av väderskyddet innan den överlämnas
            till beställaren. <br /><br />
            •Handlingar som fordras enligt AFS 2023:11
            skall överlämnas till beställaren.<br /><br />
            •Väderskyddet skall före användning och
            fortlöpande kontrolleras under användningstiden
            av beställaren enligt AFS 2023:11.<br /><br />
            •Ingrepp i väderskyddet får enbart utföras
            av personal med erforderlig utbildning,
            AFS 2023:11 och efter medgivande
            av uthyraren.<br /><br />
          </p>
        </div>
      </Col>
      <Col>
        <Row className='mt-5'>
          <YesOrNoCheckbox
            approved={props.factsAboutWeatherProtection.calculatedForPersonLoad}
            onChange={(value) => handleChange({ calculatedForPersonLoad: value })}
            radioGroup="personLast"
            useCheckboxModel
            title="BERÄKNAT FÖR PERSONLAST
                    2 x 1,2 kN enligt AFS 2023:11" />
        </Row>
        <Row className='mt-3'>
          <div className='yes-no-title snow-load-title'>1. BERÄKNAD SNÖLAST</div>
          <Row className="mb-2 p-2 snow-load-options" xs={1} md={1} lg={1}>
            <Col className='snow-load-option'>
              <input
                type="checkbox"
                className="form-check-input snow-load-checkbox"
                checked={props.factsAboutWeatherProtection.calculatedSnowLoadNone ?? false}
                onChange={() => handleCalculatedSnowLoadSelection('calculatedSnowLoadNone')}
              />
              <label>Ingen (MIN.0,1kN/m2)</label>
            </Col>
            <Col className='snow-load-option'>
              <input
                type="checkbox"
                className="form-check-input snow-load-checkbox"
                checked={props.factsAboutWeatherProtection.calculatedSnowLoadZeroPointSix ?? false}
                onChange={() => handleCalculatedSnowLoadSelection('calculatedSnowLoadZeroPointSix')}
              />
              <label>0,6 kN/m2</label>
            </Col>
            <Col className='snow-load-option'>
              <input
                type="checkbox"
                className="form-check-input snow-load-checkbox"
                checked={props.factsAboutWeatherProtection.calculatedSnowLoadAccordingToEuroCode ?? false}
                onChange={() => handleCalculatedSnowLoadSelection('calculatedSnowLoadAccordingToEuroCode')}
              />
              <label>ENLIGT EUROKOD</label>
            </Col>
          </Row>
        </Row>
        <Col xs={12} md={6} lg={12} className='align-items-center'>
          <Row>
            <YesOrNoCheckbox
              approved={props.factsAboutWeatherProtection.performedAccordingToManufacturersInstallationInstructions}
              onChange={(value) => handleChange({ performedAccordingToManufacturersInstallationInstructions: value })}
              radioGroup="2.UPPFÖRD ENL. TILLVERKARENS MONTERINGSINSTRUKTIONER"
              useCheckboxModel
              title="2.UPPFÖRD ENL. TILLVERKARENS MONTERINGSINSTRUKTIONER" />
          </Row>
          <Row>
            <div className='label-header-section'>
              <label></label>
            </div>
          </Row>
          <Row>
            <YesOrNoCheckbox
              approved={props.factsAboutWeatherProtection.thereIsANeedForAccess}
              onChange={(value) => handleChange({ thereIsANeedForAccess: value })}
              radioGroup="3.FINNS BEHOV AV TILLTRÄDESLED"
              useCheckboxModel
              title="3.FINNS BEHOV AV TILLTRÄDESLED"
            />
          </Row>
          <Row>
            <div className='label-header-section'>
              <label></label>
            </div>
          </Row>
          <Row>
            <YesOrNoCheckbox
              approved={props.factsAboutWeatherProtection.dimensionActionsExist}
              onChange={(value) => handleChange({ dimensionActionsExist: value })}
              radioGroup="dimensioneringsHandingar"
              useCheckboxModel
              title="4.DIMENSIONERINGSHANDLINGAR FINNS" />
          </Row>
          <Row>
            <div className='label-header-section'>
              <label></label>
            </div>
          </Row>
        </Col>
      </Col>
      <Row className='mt-3'>
        <Col xs={12}>
          <LabelAndTextBox title='EGENKONTROLL UTFÖRD OCH GODKÄND AV' remark={props.factsAboutWeatherProtection.selfControlCarriedOutAndApprovedBy}
            onChange={(value) => handleChange({ selfControlCarriedOutAndApprovedBy: value })} />
          <p>Montageledare/Ställningsbyggare</p>
        </Col>
        <Col xs={12}>
          <LabelAndTextBox title='AVSYNAD OCH GODKÄND AV' remark={props.factsAboutWeatherProtection.reviewedAndApprovedBy}
            onChange={(value) => handleChange({ reviewedAndApprovedBy: value })} />
          <p>Beställare/Ombud</p>
        </Col>
        <Col xs={12}>
          <div className='customer-sign d-flex align-items-center justify-content-between'>
            <label>VÄDERSKYDDET ÖVERLÄMNAD TILL BESTÄLLARE DEN:</label>
            {!Utils.isDateInitialized(props.factsAboutWeatherProtection.scaffoldingSubmittedOnDate) &&
              <span>Se QR kod</span>
            }
            <DateBox defaultValue={props.factsAboutWeatherProtection.scaffoldingSubmittedOnDate}
              onChange={(value) => handleChange({ scaffoldingSubmittedOnDate: value.toISOString() })} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default FactAboutWeatherProtection;
